// React
import React from "react";
import Typography from '@material-ui/core/Typography';
import { Button } from "@material-ui/core";

/**
 * Security Method Row Component
 * Displays a single security method option with icon, title, description, and action button
 */
const SecurityMethodRow = ({ icon, title, description, badge, actionLabel, onActionClick}) => {
     return (
          <div className='security-method-row'>
               <div className="security-method-header">
                    <div className="security-method-left">
                         <div className="security-method-icon">
                              {icon}
                         </div>
                         <div className="security-method-title-wrapper">
                              <h5 className="security-method-title">{title}</h5>
                              {badge && (
                                   <span className="recommended-badge">{badge}</span>
                              )}
                         </div>
                    </div>
                    <Button 
                         variant="outlined" 
                         color="primary"
                         onClick={onActionClick}
                         className="security-method-action-button"
                         disableRipple
                    >
                         {actionLabel}
                    </Button>
               </div>
               <Typography variant="body2" className="security-method-description">
                    {description}
               </Typography>
          </div>
     );
};

export default SecurityMethodRow;
